var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconTelegram = function SvgIconTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.272 6.593c2.838-1.3 11.11-5.06 15.155-6.522.838-.302 1.694.401 1.559 1.281l-1.814 11.809a1.296 1.296 0 0 1-1.985.892l-5.243-3.39a1.337 1.337 0 0 1-.179-2.107L12.6 3.92c.206-.197-.058-.52-.292-.356L5.41 8.385a2.329 2.329 0 0 1-2.21.248L.29 7.451a.467.467 0 0 1-.019-.858Z",
    fill: "#525252"
  })));
};

export default SvgIconTelegram;